<!-- FAQ Section -->
<section class="flex flex-col items-center gap-12 text-center" id="faq">
  <app-section-header [title]="'Frequently asked questions'">
    <p #description>
      Have questions about partnering with OpenForge for your Capacitor
      development? We've compiled answers to the most common questions. If you
      need additional information, please reach out to
      <a [href]="'mailto:' + emailOpenforge" target="_blank">OpenForge</a>.
    </p>
  </app-section-header>
  <app-faq-accordion [items]="items" class="w-full lg:w-[1024px]" />
</section>
